import React from "react";
import CategoryRoundedIcon from "@mui/icons-material/CategoryRounded";
import {
  GET_CATEGORIES_URL,
  DELETE_CATEGORY,
  SAVE_CATEGORY,
} from "../../../API/APIRoutes";
import GenericItemsListing from "../ListingItems/ListingItems";
import ItemValidationSchema from "@Utils/Validations/ItemValidationSchema";

function CategoriesListing() {
  const attributes = [{ key: "name", label: "Category Name", flex: 2 }];

  const validationSchema = ItemValidationSchema(attributes[0].key,attributes[0].label);

  return (
    <GenericItemsListing
      items_URL={GET_CATEGORIES_URL}
      SAVE_Item={SAVE_CATEGORY}
      // DELETE_Item={DELETE_CATEGORY}
      title="Categories"
      name="Category"
      icon={<CategoryRoundedIcon fontSize="large" color="white" />}
      attributes={attributes}
      validationSchema={validationSchema}
      uniqueId={"id"}
    />
  );
}

export default CategoriesListing;
